/* eslint-disable max-lines */
/******************************************************************************

Copyright (c) 2020-2022, Visual Elements AS

Permission is hereby granted, free of charge, to any person obtaining
a copy of this software and associated documentation files (the
"Software"), to deal in the Software without restriction, including
without limitation the rights to use, copy, modify, merge, publish,
distribute, sublicense, and/or sell copies of the Software, and to
permit persons to whom the Software is furnished to do so, subject to
the following conditions:

The above copyright notice and this permission notice shall be
included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

******************************************************************************/

// @format

export default {
  Area: {
    templates: {
      Area: {
        title: 'Area',
        description: '',
        constructor: '',
        thumbnail: 'ecexev.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        dataValidator: false,
        basic: {
          order: 2,
          thumbnail: 'area_graph.svg',
          icon: 'Area'
        },
        advanced: {
          name: 'Standard'
        },
        parent: 'Area',
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/ecexev.svg',
        name: 'Area'
      },
      Arearange: {
        title: 'Arearange',
        description: '',
        constructor: '',
        thumbnail: 'udepat.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'arearange',
            polar: false
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        dataValidator: false,
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/udepat.svg',
        name: 'Arearange'
      },
      'Area with labels': {
        title: 'Area with labels',
        description: '',
        constructor: '',
        thumbnail: 'atikon.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'area',
        advanced: {
          name: 'Area + label'
        },
        advancedParent: 'Area',
        dataValidator: false,
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/atikon.svg',
        name: 'Area with labels'
      },
      'Inverted area': {
        title: 'Inverted area',
        description: '',
        constructor: '',
        thumbnail: 'yqenid.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            inverted: true,
            polar: false
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        dataValidator: false,
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/yqenid.svg',
        name: 'Inverted area'
      },
      'Inverted with labels': {
        title: 'Inverted with labels',
        description: '',
        constructor: '',
        thumbnail: 'acemyq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        advanced: {
          name: 'Inverted + label'
        },
        dataValidator: false,
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/acemyq.svg',
        name: 'Inverted with labels'
      },
      'Negative color': {
        title: 'Negative color',
        description: '',
        constructor: '',
        thumbnail: 'ydypal.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              negativeColor: '#FF0000'
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        dataValidator: false,
        defaultDataType: 'negative',
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/ydypal.svg',
        name: 'Negative color'
      },
      'Step line': {
        title: 'Step line',
        description: '',
        constructor: '',
        thumbnail: 'abutix.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            area: {
              step: 'left'
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Area',
        dataValidator: false,
        thumbnail_url: 'https://app.everviz.com/static/thumbnails/abutix.svg',
        name: 'Step line'
      }
    }
  },
  Bar: {
    templates: {
      Bar: {
        title: 'Bar',
        description: '',
        constructor: '',
        thumbnail: 'ovuvul.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false,
        basic: {
          order: 3,
          thumbnail: 'bar_graph.svg',
          icon: 'Bar'
        },
        advanced: {
          name: 'Standard'
        },
        parent: 'Bar'
      },
      'Horizontal columnrange': {
        title: 'Horizontal columnrange',
        description: '',
        constructor: '',
        thumbnail: 'iqagel.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'columnrange',
            inverted: true,
            polar: false
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        defaultDataType: 'columnrange',
        dataValidator: false
      },
      'Columnrange with labels': {
        title: 'Columnrange with labels',
        description: '',
        constructor: '',
        thumbnail: 'eracar.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'columnrange',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false,
        defaultDataType: 'columnrange',
        advanced: {
          name: 'Columnrange + label'
        }
      },
      'Error bar': {
        title: 'Error bar',
        description: '',
        constructor: '',
        thumbnail: 'omikax.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'errorbar',
            inverted: true,
            polar: false
          },
          series: [
            {
              type: 'errorbar'
            },
            {
              type: 'bar'
            }
          ]
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false
      },
      Logarithmic: {
        title: 'Logarithmic',
        description: '',
        constructor: '',
        thumbnail: 'imykus.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          yAxis: {
            type: 'logarithmic',
            minorTickInterval: 'auto'
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false
      },
      'Multi color': {
        title: 'Multi color',
        description: '',
        constructor: '',
        thumbnail: 'ogixak.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              colorByPoint: true
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false
      },
      'Negative color': {
        title: 'Negative color',
        description: '',
        constructor: '',
        thumbnail: 'efygam.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              negativeColor: '#FF0000'
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Bar',
        dataValidator: false,
        defaultDataType: 'negative'
      },
      'Packed columns': {
        title: 'Packed columns',
        description: '',
        constructor: '',
        thumbnail: 'orixis.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              pointPadding: 0,
              groupPadding: 0,
              borderWidth: 0,
              shadow: false
            }
          }
        },
        sampleSet: 'bar',
        dataValidator: false,
        advancedParent: 'Bar'
      },
      'Radial bar': {
        title: 'Radial bar',
        description: '',
        constructor: '',
        thumbnail: 'radialbar.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: true
          },
          tooltip: {
            outside: true
          },
          pane: {
            size: '85%',
            innerSize: '20%',
            endAngle: 270
          },
          yAxis: {
            crosshair: {
              enabled: true,
              color: '#333'
            },
            lineWidth: 0,
            tickInterval: 25,
            reversedStacks: false,
            endOnTick: true,
            showLastLabel: true
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              borderWidth: 0,
              pointPadding: 0,
              groupPadding: 0.15
            }
          }
        },
        sampleSet: 'radial',
        dataValidator: false,
        basic: {
          order: 17,
          thumbnail: 'radial_bar_chart.svg',
          icon: 'RadialBar'
        },
        advancedParent: 'Radial Bar',
        parent: 'Bar'
      }
    },
    description: [
      'A bar chart is a chart that presents grouped data with rectangular bars with lengths proportional to the values that they represent.'
    ],
    nofits: 'The dataset must contain at least one column.',
    samples: []
  },
  Line: {
    templates: {
      Line: {
        title: 'Line',
        description: '',
        constructor: '',
        thumbnail: 'abywon.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line'
          }
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        basic: {
          order: 1,
          thumbnail: 'line_graph.svg',
          name: 'Line',
          icon: 'Line'
        },
        advanced: {
          name: 'Standard'
        },
        dataValidator: false,
        parent: 'Line'
      },
      'Error bar': {
        title: 'Error bar',
        description: '',
        constructor: '',
        thumbnail: 'ypewak.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'errorbar',
            polar: false
          },
          series: [
            {
              type: 'errorbar'
            },
            {
              type: 'line'
            }
          ]
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        dataValidator: false
      },
      Inverted: {
        title: 'Inverted',
        description: '',
        constructor: '',
        thumbnail: 'ozojul.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            inverted: true,
            polar: false
          }
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        dataValidator: false
      },
      'Logarithmic line': {
        title: 'Logarithmic line',
        description: '',
        constructor: '',
        thumbnail: 'abywon.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          yAxis: {
            type: 'logarithmic',
            minorTickInterval: 'auto'
          }
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        dataValidator: false,
        advanced: {
          name: 'Logarithmic'
        }
      },
      'Negative color': {
        title: 'Negative color',
        description: '',
        constructor: '',
        thumbnail: 'uxyfys.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          plotOptions: {
            series: {
              negativeColor: '#FF0000'
            }
          }
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        dataValidator: false,
        defaultDataType: 'negative'
      },
      Spline: {
        title: 'Spline',
        description: '',
        constructor: '',
        thumbnail: 'upafes.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'spline',
            polar: false
          }
        },
        sampleSet: 'line',
        advancedParent: 'Line',
        dataValidator: false
      },
      'Spline w/ labels': {
        title: 'Spline w/ labels',
        description: '',
        constructor: '',
        thumbnail: 'odopic.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'spline',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'line',
        dataValidator: false,
        advancedParent: 'Line',
        advanced: {
          name: 'Spline + label'
        }
      },
      'Step line': {
        title: 'Step line',
        description: '',
        constructor: '',
        thumbnail: 'akeduw.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          plotOptions: {
            line: {
              step: 'left'
            }
          }
        },
        sampleSet: 'line',
        dataValidator: false,
        advancedParent: 'Line',
        advanced: {
          name: 'Step'
        }
      },
      'Step line with labels': {
        title: 'Step line with labels',
        description: '',
        constructor: '',
        thumbnail: 'oxenux.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            },
            line: {
              step: 'left'
            }
          }
        },
        sampleSet: 'line',
        dataValidator: false,
        advancedParent: 'Line',
        advanced: {
          name: 'Step + label'
        }
      },
      'With data labels': {
        title: 'With data labels',
        description: '',
        constructor: '',
        thumbnail: 'agonam.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'line',
        dataValidator: false,
        advancedParent: 'Line',
        advanced: {
          name: 'Line + label'
        }
      }
    },
    description: [
      'A line chart is a type of chart which diplays information as a series of data points called "markers" connected by straight line segments'
    ],
    samples: ['os-stats', 'line-series-simple', 'line-series-four-series']
  },
  Pie: {
    templates: {
      Pie: {
        title: 'Pie',
        description: ['Good starting point for custom pie series.'],
        constructor: 'Chart',
        thumbnail: 'yqoxob.svg',
        icon: '',
        sampleSets: [],
        validator: 'pie',
        config: {
          chart: {
            type: 'pie'
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        advancedParent: 'Pie',
        basic: {
          order: 4,
          thumbnail: 'pie_chart.svg',
          icon: 'Pie'
        },
        advanced: {
          name: 'Standard'
        },
        sampleSet: 'pie',
        parent: 'Pie'
      },
      'Pie w/ legend': {
        title: 'Pie w/ legend',
        description: '',
        constructor: '',
        thumbnail: 'anofof.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            polar: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: true,
              showInLegend: true,
              dataLabels: {
                enabled: false
              }
            }
          }
        },
        sampleSet: 'pie',
        advancedParent: 'Pie',
        dataValidator: false,
        advanced: {
          name: 'Pie + legend'
        }
      },
      '3D Pie w/ legend': {
        title: '3D Pie w/ legend',
        description: '',
        constructor: '',
        thumbnail: 'ubopaq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            },
            polar: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              depth: 35,
              cursor: 'pointer',
              showInLegend: true,
              dataLabels: {
                enabled: false
              }
            }
          }
        },
        sampleSet: 'pie',
        advancedParent: 'Pie',
        dataValidator: false,
        advanced: {
          name: '3D + legend'
        }
      },
      '3D Pie': {
        title: '3D Pie',
        description: '',
        constructor: '',
        thumbnail: 'erifer.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            },
            polar: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              depth: 35,
              cursor: 'pointer'
            },
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        advancedParent: 'Pie',
        advanced: {
          name: '3D'
        }
      }
    },
    description: [
      'A pie chart is a circular statistical graphic which is divided into slices to illustrate numerical proportions.',
      'In a pie chart, the arc length of each slice is proportional to the quantity it represents.'
    ],
    samples: ['pie-series-simple']
  },
  Column: {
    templates: {
      Column: {
        title: 'Column',
        description: '',
        constructor: '',
        thumbnail: 'ovobiq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false,
            inverted: false
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Column',
        basic: {
          order: 2,
          thumbnail: 'column_graph.svg',
          icon: 'Column'
        },
        advanced: {
          name: 'Standard'
        },
        parent: 'Column'
      },
      'Column 3D': {
        title: 'Column 3D',
        description: '',
        constructor: '',
        thumbnail: 'ahyqyx.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            margin: 75,
            options3d: {
              enabled: true,
              alpha: 15,
              beta: 15,
              depth: 50,
              viewDistance: 15
            },
            polar: false
          },
          plotOptions: {
            column: {
              depth: 25
            }
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Column',
        advanced: {
          name: '3D'
        }
      },
      Columnrange: {
        title: 'Columnrange',
        description: '',
        constructor: '',
        thumbnail: 'ihilaq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'columnrange',
            polar: false
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Column',
        defaultDataType: 'columnrange'
      },
      'Columnrange with labels': {
        title: 'Columnrange with labels',
        description: '',
        constructor: '',
        thumbnail: 'ojykiw.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'columnrange',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'column',
        advanced: {
          name: 'Columnrange + label'
        },
        dataValidator: false,
        advancedParent: 'Column',
        defaultDataType: 'columnrange'
      },
      'Error bar': {
        title: 'Error bar',
        description: '',
        constructor: '',
        thumbnail: 'icytes.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'errorbar',
            polar: false
          },
          series: [
            {
              type: 'errorbar'
            },
            {
              type: 'column'
            }
          ]
        },
        sampleSet: 'column',
        advancedParent: 'Column',
        dataValidator: false
      },
      'With label': {
        title: 'With label',
        description: '',
        constructor: '',
        thumbnail: 'ivetir.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        advancedParent: 'Column',
        advanced: {
          name: 'Column + label'
        },
        sampleSet: 'column',
        dataValidator: false
      },
      Logarithmic: {
        title: 'Logarithmic',
        description: '',
        constructor: '',
        thumbnail: 'igipeg.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          yAxis: {
            type: 'logarithmic',
            minorTickInterval: 'auto'
          }
        },
        sampleSet: 'column',
        advancedParent: 'Column',
        dataValidator: false
      },
      'Multi color': {
        title: 'Multi color',
        description: '',
        constructor: '',
        thumbnail: 'alyqyz.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              colorByPoint: true
            }
          }
        },
        sampleSet: 'column',
        advancedParent: 'Column',
        dataValidator: false
      },
      'Negative color': {
        title: 'Negative color',
        description: '',
        constructor: '',
        thumbnail: 'yxajih.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              negativeColor: '#FF0000'
            }
          }
        },
        sampleSet: 'column',
        advancedParent: 'Column',
        dataValidator: false,
        defaultDataType: 'negative'
      },
      'Packed columns': {
        title: 'Packed columns',
        description: '',
        constructor: '',
        thumbnail: 'exypor.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              pointPadding: 0,
              groupPadding: 0,
              borderWidth: 0,
              shadow: false
            }
          }
        },
        sampleSet: 'column',
        advancedParent: 'Column',
        dataValidator: false
      }
    },
    description: [],
    samples: []
  },
  Stock: {
    templates: {
      'Area stock': {
        title: 'Area stock',
        description: '',
        constructor: 'StockChart',
        thumbnail: 'ukaqor.svg',
        icon: '',
        sampleSets: ['line-series-dates'],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              },
              lineWidth: 2
            }
          },
          rangeSelector: {
            enabled: true
          }
        },
        sampleSet: 'stock',
        dataValidator: false,
        advancedParent: 'Stock',
        defaultDataType: 'stock-line'
      },
      Stock: {
        title: 'Stock',
        description: '',
        constructor: 'StockChart',
        thumbnail: 'awuhad.svg',
        icon: '',
        sampleSets: ['line-series-dates'],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: false
          },
          rangeSelector: {
            enabled: true
          }
        },
        sampleSet: 'stock',
        defaultDataType: 'stock-line',
        advancedParent: 'Stock',
        basic: {
          order: 15,
          thumbnail: 'stacked_area_graph.svg',
          icon: 'StackedArea'
        },
        dataValidator: false,
        parent: 'Stock'
      },
      Candlestick: {
        title: 'Candlestick',
        description: '',
        constructor: 'StockChart',
        thumbnail: 'etybef.svg',
        icon: '',
        sampleSets: ['candlestick'],
        validator: false,
        config: {
          chart: {
            type: 'candlestick',
            polar: false
          },
          plotOptions: {
            series: {
              lineWidth: 1,
              pointPadding: 0.2,
              groupPadding: 0.2
            }
          },
          rangeSelector: {
            enabled: true
          }
        },
        sampleSet: 'candlestick',
        advancedParent: 'Candlestick',
        defaultDataType: 'stock-ohlc',
        dataValidator: false,
        basic: {
          order: 21,
          thumbnail: 'candlestick_chart.svg',
          icon: 'Candlestick'
        },
        parent: 'Stock'
      },
      Column: {
        title: 'Column',
        description: '',
        constructor: 'StockChart',
        thumbnail: 'ogywen.svg',
        icon: '',
        sampleSets: ['line-series-dates'],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          rangeSelector: {
            enabled: true
          }
        },
        advancedParent: 'Stock',
        sampleSet: 'column',
        dataValidator: false
      },
      OHLC: {
        title: 'OHLC',
        description: '',
        constructor: 'StockChart',
        thumbnail: 'opilip.svg',
        icon: '',
        sampleSets: ['candlestick'],
        validator: false,
        config: {
          chart: {
            type: 'ohlc',
            polar: false
          },
          plotOptions: {
            series: {
              lineWidth: 1,
              pointPadding: 0.2,
              groupPadding: 0.2
            }
          },
          rangeSelector: {
            enabled: true
          }
        },
        advancedParent: 'OHLC',
        defaultDataType: 'stock-ohlc',
        sampleSet: 'ohlc',
        dataValidator: false,
        basic: {
          order: 16,
          thumbnail: 'open-high-low-close.svg',
          icon: 'OHLC'
        },
        parent: 'Stock'
      }
    },
    description: ['Stock charts are used to display financial data.'],
    samples: []
  },
  'Scatter chart': {
    templates: {
      'Scatter w/ line': {
        title: 'Scatter w/ line',
        description: '',
        constructor: '',
        thumbnail: 'ydaqok.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'scatter',
            polar: false
          },
          plotOptions: {
            series: {
              lineWidth: 1
            }
          }
        },
        sampleSet: 'scatter',
        advancedParent: 'Scatter chart',
        dataValidator: false,
        advanced: {
          name: 'Scatter + line'
        }
      },
      'Scatter chart': {
        title: 'Scatter chart',
        description: '',
        constructor: '',
        thumbnail: 'ezatat.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'scatter',
            polar: false
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              },
              lineWidth: 0
            }
          }
        },
        sampleSet: 'scatter',
        dataValidator: false,
        advancedParent: 'Scatter chart',
        advanced: {
          name: 'Standard'
        },
        basic: {
          order: 10,
          thumbnail: 'scatterplot.svg',
          icon: 'Scatter'
        },
        parent: 'Scatter chart'
      },
      'Scatter with line, no marker': {
        title: 'Scatter with line, no marker',
        description: '',
        constructor: '',
        thumbnail: 'uvepiw.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'scatter',
            polar: false
          },
          plotOptions: {
            series: {
              lineWidth: 1,
              marker: {
                enabled: false
              }
            }
          }
        },
        sampleSet: 'scatter',
        advancedParent: 'Scatter',
        dataValidator: false
      }
    }
  },
  Timeline: {
    templates: {
      Timeline: {
        title: 'Timeline',
        description: '',
        constructor: '',
        thumbnail: 'timeline-dots.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'timeline'
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true,
                symbol: 'circle'
              }
            }
          },
          tooltip: {
            headerFormat: '{point.x}<br/>'
          },
          xAxis: {
            type: 'datetime',
            visible: false
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: false
          }
        },
        dataValidator: false,
        sampleSet: 'timeline',
        plugins: ['timeline'],
        advancedParent: 'Timeline',
        basic: {
          order: 30,
          thumbnail: 'timeline.svg',
          icon: 'Timeline'
        },
        advanced: {
          name: 'Standard'
        },
        parseData: 'timeline',
        parent: 'Timeline'
      },
      'Timeline blocks': {
        title: 'Timeline blocks',
        description: '',
        constructor: '',
        thumbnail: 'timeline.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'timeline'
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              }
            }
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: false
          }
        },
        sampleSet: 'timeline',
        dataValidator: false,
        plugins: ['timeline'],
        advancedParent: 'Timeline',
        parseData: 'timeline'
      }
    }
  },
  More: {
    templates: {
      'Dependancy wheel': {
        title: 'Dependancy wheel',
        description: '',
        constructor: '',
        thumbnail: 'dependancywheel.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'dependencywheel'
          },
          plotOptions: {
            series: {
              borderRadius: false
            }
          }
        },
        plugins: ['dependancywheel'],
        advancedParent: 'Dependancy wheel',
        sampleSet: 'dependancywheel',
        basic: {
          order: 9,
          thumbnail: 'dependancy_wheel.svg',
          icon: 'DependencyWheel'
        },
        dataValidator: false,
        parent: 'More'
      },
      Sankey: {
        title: 'Sankey',
        description: '',
        constructor: '',
        thumbnail: 'sankey.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'sankey'
          }
        },
        plugins: ['sankey'],
        sampleSet: 'sankey',
        advancedParent: 'Sankey',
        basic: {
          order: 11,
          thumbnail: 'sankey_diagram.svg',
          icon: 'Sankey'
        },
        dataValidator: false,
        parent: 'More'
      },
      Dumbbell: {
        title: 'Dumbbell',
        description: '',
        constructor: '',
        thumbnail: 'dumbell.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'dumbbell'
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              }
            }
          }
        },
        plugins: ['dumbbell'],
        sampleSet: 'dumbbell',
        advancedParent: 'Dumbbell',
        dataValidator: false,
        basic: {
          order: 25,
          thumbnail: 'dumbbell_chart.svg',
          icon: 'Dumbbell'
        },
        parent: 'More'
      },
      Heatmap: {
        title: 'Heatmap',
        description: '',
        constructor: '',
        thumbnail: 'heatmap.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'heatmap'
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              lineWidth: 0,
              minSize: 4,
              maxSize: 60,
              marker: {
                enabled: true
              }
            }
          },
          tooltip: {
            pointFormat: '{point.xLabel}, {point.yLabel}: {point.value}'
          },
          colorAxis: {
            minColor: '#FFFFFF',
            maxColor: '#FF495E',
            stops: [
              [0, '#FFFFFF'],
              [1, '#FF495E']
            ]
          }
        },
        plugins: ['heatmap'],
        dataValidator: false,
        isNew: true,
        advancedParent: 'Heatmap',
        sampleSet: 'heatmap',
        basic: {
          order: 28,
          thumbnail: 'heat_map.svg',
          icon: 'Heatmap'
        },
        parseData: 'heatmap',
        parent: 'More'
      },
      'Unit chart': {
        title: 'Unit chart',
        description: '',
        constructor: '',
        thumbnail: 'item-icon.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'item'
          },
          exporting: {}
        },
        sampleSet: 'unit',
        plugins: ['icon-chart'],
        advancedParent: 'Unit chart',
        dataValidator: false,
        basic: {
          order: 9,
          thumbnail: 'icon-unit.svg',
          icon: 'Unit'
        },
        skipEmit: true,
        parent: 'More'
      },
      Boxplot: {
        title: 'Boxplot',
        description: '',
        constructor: '',
        thumbnail: 'idagib.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'boxplot'
          }
        },
        sampleSet: 'boxplot',
        advancedParent: 'Boxplot',
        dataValidator: false,
        basic: {
          order: 22,
          thumbnail: 'box_plot.svg',
          icon: 'Boxplot'
        },
        parent: 'More'
      },
      Funnel: {
        title: 'Funnel',
        description: '',
        constructor: '',
        thumbnail: 'exumeq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'funnel'
          },
          plotOptions: {
            series: {
              datalabels: {
                color: '#000000'
              },
              dataLabels: {
                softConnector: true
              },
              neckWidth: '20%',
              neckHeight: '35%'
            }
          },
          'series[0]': {
            width: '64%'
          }
        },
        sampleSet: 'funnel',
        advancedParent: 'Funnel',
        dataValidator: false,
        basic: {
          order: 26,
          thumbnail: 'funnel_chart.svg',
          icon: 'Funnel'
        },
        parent: 'More'
      },
      Pyramid: {
        title: 'Pyramid',
        description: '',
        constructor: '',
        thumbnail: 'obulek.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pyramid'
          },
          plotOptions: {
            series: {
              datalabels: {
                color: '#000000'
              },
              dataLabels: {
                softConnector: true
              }
            }
          },
          'series[0]': {
            width: '64%'
          }
        },
        sampleSet: 'pyramid',
        advancedParent: 'More',
        dataValidator: false
      },
      'Solid gauge': {
        title: 'Solid gauge',
        description: '',
        constructor: '',
        thumbnail: 'apocob.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'solidgauge'
          },
          pane: {
            center: ['50%', '85%'],
            size: '140%',
            startAngle: '-90',
            endAngle: '90',
            background: {
              backgroundColor: '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
            }
          },
          tooltip: {
            enabled: false
          },
          yAxis: {
            stops: [
              [0.1, '#55BF3B'],
              [0.5, '#DDDF0D'],
              [0.9, '#DF5353']
            ],
            min: 0,
            max: 100,
            lineWidth: 0,
            minorTickInterval: null,
            tickPixelInterval: 400,
            tickWidth: 0,
            title: {
              y: -70
            },
            labels: {
              y: 16
            }
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: 10,
                borderWidth: 0,
                useHTML: true
              }
            }
          },
          'series[0]': {
            dataLabels: {
              format: '<div style="text-align:center"><span style="font-size:25px;color:#000000">{y}</span></div>'
            }
          }
        },
        sampleSet: 'solidgauge',
        advancedParent: 'Solid guage',
        dataValidator: false,
        basic: {
          order: 27,
          thumbnail: 'gauge_chart.svg',
          icon: 'SolidGauge'
        },
        parent: 'More'
      },
      Parliament: {
        title: 'Parliament',
        description: '',
        constructor: '',
        thumbnail: 'parliament.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'item'
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: false,
                format: '{point.label}'
              },
              center: ['50%', '88%'],
              startAngle: -100,
              endAngle: 100
            }
          },
          legend: {
            labelFormat: '{name} <span style="opacity: 0.4">{y}</span>'
          }
        },
        plugins: ['parliament'],
        sampleSet: 'parliament',
        dataValidator: false,
        advancedParent: 'Parliament',
        defaultDataType: 'parliament',
        basic: {
          order: 26,
          thumbnail: 'parliament.svg',
          icon: 'Parliament'
        },
        parent: 'More'
      },
      'Spider area': {
        title: 'Spider area',
        description: '',
        constructor: '',
        thumbnail: 'exajib.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: true
          },
          xAxis: {
            tickmarkPlacement: 'on',
            lineWidth: 0
          },
          yAxis: {
            lineWidth: 0,
            gridLineInterpolation: 'polygon'
          }
        },
        sampleSet: 'polar',
        dataValidator: false,
        advancedParent: 'Spider',
        basic: {
          order: 24,
          thumbnail: 'spider_chart.svg',
          icon: 'SpiderArea'
        },
        parent: 'More'
      },
      'Spider line': {
        title: 'Spider line',
        description: '',
        constructor: '',
        thumbnail: 'uqonaj.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: true
          },
          xAxis: {
            tickmarkPlacement: 'on',
            lineWidth: 0
          },
          yAxis: {
            lineWidth: 0,
            gridLineInterpolation: 'polygon'
          }
        },
        sampleSet: 'polar',
        dataValidator: false,
        advancedParent: 'Spider'
      },
      'Stream graph': {
        title: 'Stream graph',
        description: '',
        constructor: '',
        thumbnail: 'streamgraph.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'streamgraph'
          },
          plotOptions: {
            series: {
              label: {
                enabled: true
              }
            }
          },
          yAxis: {
            visible: false,
            startOnTick: false,
            endOnTick: false
          },
          xAxis: {
            lineWidth: 0,
            crosshair: true
          },
          legend: {
            enabled: false
          }
        },
        dataValidator: false,
        plugins: ['streamgraph'],
        sampleSet: 'streamgraph',
        advancedParent: 'Streamgraph',
        basic: {
          order: 29,
          thumbnail: 'stream_graph.svg',
          icon: 'StreamGraph'
        },
        parseData: 'streamgraph',
        parent: 'More'
      },
      Waterfall: {
        title: 'Waterfall',
        description: '',
        constructor: '',
        thumbnail: 'waterfall.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'waterfall',
            polar: false
          }
        },
        sampleSet: 'waterfall',
        advancedParent: 'Waterfall',
        dataValidator: false,
        basic: {
          order: 23,
          thumbnail: 'waterfall.svg',
          icon: 'Waterfall'
        },
        parent: 'More'
      },
      'Word cloud': {
        title: 'Word cloud',
        description: '',
        constructor: '',
        thumbnail: 'wordcloud.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'wordcloud'
          },
          legend: {
            enabled: false
          }
        },
        plugins: ['wordcloud'],
        advancedParent: 'Wordcloud',
        sampleSet: 'wordcloud',
        dataValidator: false,
        usesTextArea: true,
        basic: {
          order: 10,
          thumbnail: 'word_cloud.svg',
          icon: 'WordCloud'
        },
        parent: 'More'
      },
      'Tree map': {
        title: 'Tree map',
        description: '',
        constructor: '',
        thumbnail: 'wordcloud.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'treemap'
          },
          plotOptions: {
            series: {
              colorByPoint: true,
              levels: [
                {
                  level: 1,
                  layoutAlgorithm: 'sliceAndDice'
                }
              ],
              dataLabels: {
                enabled: true,
                align: 'left',
                format: '{point.name}',
                verticalAlign: 'top',
                style: {
                  fontSize: '15px',
                  fontWeight: 'bold'
                }
              }
            }
          },
          legend: {
            enabled: false
          }
        },
        plugins: ['treemap'],
        advancedParent: 'Treemap',
        sampleSet: 'wordcloud',
        dataValidator: false,
        basic: {
          order: 10,
          thumbnail: 'word_cloud.svg',
          icon: 'Treemap'
        },
        parent: 'More'
      }
    }
  },
  'Stacked area': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Stacked percentage': {
        title: 'Stacked percentage',
        description: '',
        constructor: '',
        thumbnail: 'iporos.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'percent'
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Stacked area',
        dataValidator: false,
        advanced: {
          name: 'Standard'
        }
      },
      'Stacked area': {
        title: 'Stacked area',
        description: '',
        constructor: '',
        thumbnail: 'inebav.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal'
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Stacked area',
        dataValidator: false,
        basic: {
          order: 14,
          thumbnail: 'stacked_area_graph.svg',
          icon: 'StackedArea'
        },
        parent: 'Stacked area'
      },
      'Stacked with labels': {
        title: 'Stacked with labels',
        description: '',
        constructor: '',
        thumbnail: 'iluryh.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'area',
        advancedParent: 'Stacked area',
        advanced: {
          name: 'Stacked + label'
        },
        dataValidator: false
      }
    }
  },
  'Stacked bar': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Stacked bar': {
        title: 'Stacked bar',
        description: '',
        constructor: '',
        thumbnail: 'epodat.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal'
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Stacked bar',
        dataValidator: false,
        advanced: {
          name: 'Standard'
        },
        basic: {
          order: 8,
          thumbnail: 'stacked_bar_graph.svg',
          icon: 'StackedBar'
        },
        parent: 'Stacked bar'
      },
      'Stacked bar w/ labels': {
        title: 'Stacked bar w/ labels',
        description: '',
        constructor: '',
        thumbnail: 'otupaz.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Stacked bar',
        dataValidator: false,
        advanced: {
          name: 'Stacked + label'
        }
      },
      'Stacked percent bar': {
        title: 'Stacked percent bar',
        description: '',
        constructor: '',
        thumbnail: 'yhekaq.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'percent'
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Stacked bar',
        dataValidator: false,
        advanced: {
          name: 'Percent'
        }
      },
      'Stacked bar percent w/ labels': {
        title: 'Stacked bar percent w/ labels',
        description: '',
        constructor: '',
        thumbnail: 'izoqyx.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'percent',
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Stacked bar',
        dataValidator: false,
        advanced: {
          name: 'Percent + label'
        }
      },
      'Bar with labels': {
        title: 'Bar with labels',
        description: '',
        constructor: '',
        thumbnail: 'ovuvul.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            inverted: true,
            polar: false
          },
          plotOptions: {
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'bar',
        advancedParent: 'Stacked bar',
        advanced: {
          name: 'Stacked + label'
        },
        dataValidator: false
      }
    }
  },
  'Stacked column': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Stacked 3D': {
        title: 'Stacked 3D',
        description: '',
        constructor: '',
        thumbnail: 'ahyqyx.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            margin: 75,
            options3d: {
              enabled: true,
              alpha: 15,
              beta: 15,
              depth: 50,
              viewDistance: 15
            },
            polar: false
          },
          plotOptions: {
            column: {
              depth: 25
            },
            series: {
              stacking: 'normal'
            }
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Stacked column',
        advanced: {
          name: '3D'
        }
      },
      'Stacked column percent': {
        title: 'Stacked column percent',
        description: '',
        constructor: '',
        thumbnail: 'ojixow.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column'
          },
          plotOptions: {
            series: {
              stacking: 'percent'
            }
          },
          yAxis: {
            reversedStacks: false
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Stacked column',
        advanced: {
          name: 'Percent'
        }
      },
      'Stacked percent with labels': {
        title: 'Stacked percent with labels',
        description: '',
        constructor: '',
        thumbnail: 'iwanyg.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'percent',
              dataLabels: {
                enabled: true
              }
            }
          },
          yAxis: {
            reversedStacks: false
          }
        },
        sampleSet: 'column',
        advancedParent: 'Stacked column',
        dataValidator: false,
        advanced: {
          name: 'Percent + label'
        }
      },
      'Stacked column': {
        title: 'Stacked column',
        description: '',
        constructor: '',
        thumbnail: 'ycehiz.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal'
            }
          },
          yAxis: {
            reversedStacks: false
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Stacked column',
        advanced: {
          name: 'Standard'
        },
        basic: {
          order: 7,
          thumbnail: 'stacked-column.svg',
          icon: 'StackedColumn'
        },
        parent: 'Stacked column'
      },
      'Stacked column w/ labels': {
        title: 'Stacked column w/ labels',
        description: '',
        constructor: '',
        thumbnail: 'acijil.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'column',
            polar: false
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              dataLabels: {
                enabled: true
              }
            }
          },
          yAxis: {
            reversedStacks: false
          }
        },
        sampleSet: 'column',
        dataValidator: false,
        advancedParent: 'Stacked column',
        advanced: {
          name: 'Stacked column + label'
        }
      }
    }
  },
  Donut: {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      Donut: {
        title: 'Donut',
        description: '',
        constructor: '',
        thumbnail: 'upaxab.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            polar: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: true,
              innerSize: '60%'
            },
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        basic: {
          order: 6,
          thumbnail: 'donut_chart.svg',
          icon: 'Donut'
        },
        advanced: {
          name: 'Standard'
        },
        advancedParent: 'Donut',
        parent: 'Donut'
      },
      '3D Donut': {
        title: '3D Donut',
        description: '',
        constructor: '',
        thumbnail: 'ehuvoh.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            },
            polar: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              depth: 35,
              cursor: 'pointer',
              innerSize: '60%'
            },
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        advanced: {
          name: '3D'
        },
        advancedParent: 'Donut'
      },
      '3D Donut w/ legend': {
        title: '3D Donut w/ legend',
        description: '',
        constructor: '',
        thumbnail: 'oriwyb.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
            },
            polar: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              depth: 35,
              cursor: 'pointer',
              showInLegend: true,
              innerSize: '60%'
            },
            series: {
              dataLabels: {
                enabled: false
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        advanced: {
          name: '3D + legend'
        },
        advancedParent: 'Donut'
      },
      'Donut w/ legend': {
        title: 'Donut w/ legend',
        description: '',
        constructor: '',
        thumbnail: 'arutag.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            polar: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: true,
              showInLegend: true,
              innerSize: '60%',
              dataLabels: {
                enabled: false
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        advancedParent: 'Donut',
        advanced: {
          name: 'Donut + legend'
        }
      },
      'Semi circle donut': {
        title: 'Semi circle donut',
        description: '',
        constructor: '',
        thumbnail: 'iwyfes.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'pie',
            polar: false
          },
          plotOptions: {
            pie: {
              allowPointSelect: false,
              dataLabels: {
                distance: -30,
                style: {
                  fontWeight: 'bold',
                  color: 'white',
                  textShadow: '0px 1px 2px black'
                }
              },
              innerSize: '50%',
              startAngle: -90,
              endAngle: 90,
              center: ['50%', '75%']
            },
            series: {
              dataLabels: {
                enabled: true
              }
            }
          }
        },
        sampleSet: 'pie',
        dataValidator: false,
        advancedParent: 'Donut',
        advanced: {
          name: 'Semicircle'
        }
      }
    }
  },
  'Bubble chart': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Bubble chart': {
        title: 'Bubble chart',
        description: '',
        constructor: '',
        thumbnail: 'usyfyw.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'bubble',
            polar: false
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              },
              lineWidth: 0
            }
          }
        },
        sampleSet: 'bubble',
        dataValidator: false,
        advancedParent: 'Bubble chart',
        basic: {
          order: 18,
          thumbnail: 'bubble_chart.svg',
          icon: 'Bubble'
        },
        parent: 'Bubble chart'
      }
    }
  },
  Map: {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      Choropleth: {
        title: 'Choropleth',
        description: [
          'Choropleth Maps display divided geographical areas or regions that are coloured in relation to a data variable.',
          'This provides a way to visualise values over a geographical area, which can show variation across the displayed location.',
          'The Choropleth template displays a color axis represented by a gradient'
        ],
        constructor: 'Map',
        thumbnail: 'mapchoropleth.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {},
          mapNavigation: {
            enabled: true,
            buttonOptions: {
              verticalAlign: 'bottom'
            }
          },
          plotOptions: {
            series: {
              lineWidth: 1
            }
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          colorAxis: {
            type: 'logarithmic',
            minColor: '#EEEEFF',
            maxColor: '#000022',
            stops: [
              [0, '#EFEFFF'],
              [0.67, '#FF495E'],
              [1, '#000022']
            ]
          }
        },
        dataValidator: false,
        sampleSet: 'choropleth',
        isMap: true,
        advancedParent: 'Choropleth',
        defaultDataType: 'choropleth',
        basic: {
          order: 1,
          thumbnail: 'choropleth_map.svg',
          icon: 'Choropleth'
        }
      },
      Categories: {
        title: 'Categories',
        description: [
          'Similar to the Choroplketh, except that the geographical regions colors are split based on specific ranges.'
        ],
        constructor: 'Map',
        thumbnail: 'us-election.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {},
          mapNavigation: {
            enabled: true
          },
          plotOptions: {
            series: {
              borderWidth: 1,
              lineWidth: 1
            }
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          colorAxis: {
            type: null,
            min: null,
            minColor: null,
            maxColor: null,
            stops: null,
            dataClasses: []
          }
        },
        dataValidator: false,
        sampleSet: 'category',
        advancedParent: 'Categories',
        defaultDataType: 'categoriesMap',
        isMap: true,
        basic: {
          order: 2,
          thumbnail: 'categories_map.svg',
          icon: 'Categories'
        }
      },
      Bubble: {
        title: 'Bubble',
        description: [
          'The bubble map uses circles of different size to represent a numeric value on a territory. It displays one bubble per region. The bubble is displayed in the baricentre of the region).'
        ],
        constructor: 'Map',
        thumbnail: 'mapbubble.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {},
          mapNavigation: {
            enabled: true,
            buttonOptions: {
              verticalAlign: 'bottom'
            }
          },
          xAxis: {
            visible: false,
            type: 'linear'
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: false
          },
          colorAxis: {
            minColor: '#EEEEFF',
            maxColor: '#000022',
            stops: [
              [0, '#EFEFFF'],
              [0.67, '#FF495E'],
              [1, '#000022']
            ]
          },
          plotOptions: {
            series: {
              lineWidth: 0,
              minSize: 4,
              maxSize: 60,
              borderWidth: 1,
              marker: {
                enabled: true
              }
            }
          },
          series: [
            {
              type: 'map'
            },
            {
              joinBy: 'hc-key',
              type: 'mapbubble'
            }
          ]
        },
        dataValidator: false,
        sampleSet: 'mapbubble',
        loadForEachSeries: false,
        advancedParent: 'Bubble',
        defaultDataType: 'bubbleMap',
        isMap: true,
        basic: {
          order: 3,
          thumbnail: 'bubble_map.svg',
          icon: 'BubbleMap'
        }
      },
      'Tilemap circle': {
        title: 'Tilemap circle',
        description: [
          'Tilemaps are maps where each area is represented by tiles of equal shape. You can choose from circle or honeycomb which uses hexagonal tiles.'
        ],
        constructor: 'Chart',
        thumbnail: 'mapcircle.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'tilemap',
            inverted: true
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          colorAxis: {
            dataClasses: [
              {
                from: 0,
                to: 1000000,
                color: '#e8f5e9',
                name: 'Weak'
              },
              {
                from: 1000000,
                to: 5000000,
                color: '#81c784',
                name: 'Average'
              },
              {
                from: 5000000,
                to: 20000000,
                color: '#43a047',
                name: 'Strong'
              },
              {
                from: 20000000,
                color: '#1b5e20',
                name: 'Stellar'
              }
            ]
          },
          tooltip: {
            headerFormat: '',
            pointFormat: 'The real GDP growth of <b>{point.name}</b> is <b>{point.value}</b> %'
          },
          plotOptions: {
            series: {
              tileShape: 'circle',
              lineWidth: 0,
              borderRadius: 0,
              dataLabels: {
                enabled: true,
                format: '{point.hc-a2}',
                color: '#000000',
                style: {
                  textOutline: false
                }
              }
            }
          }
        },
        sampleSet: 'maptile',
        dataValidator: false,
        defaultDataType: 'tilemapCircle',
        isMap: true,
        advancedParent: 'Tilemap circle',
        basic: {
          order: 4,
          thumbnail: 'tile_map.svg',
          icon: 'TilemapCircle'
        }
      },
      Honeycomb: {
        title: 'Honeycomb',
        description: [
          'Tilemaps are maps where each area is represented by tiles of equal shape. You can choose from circle or honeycomb which uses hexagonal tiles.'
        ],
        constructor: 'Chart',
        thumbnail: 'maphoneycomb.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'tilemap',
            inverted: true
          },
          xAxis: {
            visible: false
          },
          yAxis: {
            visible: false
          },
          colorAxis: {
            dataClasses: [
              {
                from: 0,
                to: 1000000,
                color: '#F9EDB3',
                name: '< 1M'
              },
              {
                from: 1000000,
                to: 5000000,
                color: '#FFC428',
                name: '1M - 5M'
              },
              {
                from: 5000000,
                to: 20000000,
                color: '#FF7987',
                name: '5M - 20M'
              },
              {
                from: 20000000,
                color: '#FF2371',
                name: '> 20M'
              }
            ]
          },
          plotOptions: {
            series: {
              lineWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.hc-a2}',
                color: '#000000',
                style: {
                  textOutline: false
                }
              }
            }
          }
        },
        sampleSet: 'maptile',
        dataValidator: false,
        isMap: true,
        advancedParent: 'Honeycomb',
        defaultDataType: 'honeycomb',
        basic: {
          order: 5,
          thumbnail: 'honeycomb_map.svg',
          icon: 'Honeycomb'
        }
      },
      'Pattern fill': {
        title: 'Pattern fill',
        description: [
          'Pattern Fill Maps display divided geographical areas or regions that are patterned in relation to an image source. This provides a way to visualise values over a geographical area.'
        ],
        constructor: 'Map',
        thumbnail: 'mappatternfill.png',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {},
          xAxis: {
            minRange: 3500,
            visible: false
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              states: {
                hover: {
                  color: ''
                }
              }
            }
          },
          tooltip: {
            useHTML: true,
            borderColor: '#aaa',
            headerFormat: '<b>{point.point.name}</b><br>',
            pointFormat: '<img style="width: 150px; height: 100px;" src=\'{point.options.color.pattern.image}\'>'
          }
        },
        sampleSet: 'mappattern',
        dataValidator: false,
        type: 'patternfill',
        isMap: true,
        advancedParent: 'Pattern fill',
        defaultDataType: 'patternfill',
        basic: {
          order: 6,
          thumbnail: 'pattern_fill.svg',
          icon: 'PatternFill'
        }
      },
      'Point map': {
        title: 'Point map',
        description: [
          'Point maps can be used to show the distribution of data over a geographical region, by placing equally sized markers over the region.'
        ],
        constructor: 'Map',
        thumbnail: 'mappoint.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {},
          mapNavigation: {
            enabled: true,
            buttonOptions: {
              verticalAlign: 'bottom'
            }
          },
          xAxis: {
            visible: false
          },
          plotOptions: {
            series: {
              lineWidth: 0,
              borderWidth: 1,
              marker: {
                enabled: true
              },
              fillColor: 'black'
            }
          },
          yAxis: {
            visible: false
          },
          legend: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          series: [
            {
              type: 'map'
            },
            {
              joinBy: 'hc-key',
              type: 'mappoint'
            }
          ]
        },
        sampleSet: 'mappoint',
        dataValidator: false,
        loadForEachSeries: false,
        defaultDataType: 'pointMap',
        isMap: true,
        advancedParent: 'Point map',
        basic: {
          order: 7,
          thumbnail: 'point_map.svg',
          icon: 'PointMap'
        }
      }
    }
  },
  PackedBubble: {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Packed bubble': {
        title: 'Packed bubble',
        description: '',
        constructor: '',
        thumbnail: 'packed.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'packedbubble'
          },
          legend: {
            itemMarginBottom: 4,
            margin: 0,
            padding: 0
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              },
              lineWidth: 0
            },
            packedbubble: {
              minSize: '30%',
              maxSize: '120%'
            }
          }
        },
        parseData: 'packedbubble',
        plugins: ['packedbubble'],
        advancedParent: 'PackedBubble',
        sampleSet: 'packedbubble',
        dataValidator: false,
        basic: {
          order: 10,
          thumbnail: 'word_cloud.svg',
          icon: 'PackedBubble'
        },
        advanced: {
          name: 'Standard'
        },
        parent: 'PackedBubble'
      },
      Grouped: {
        title: 'Grouped',
        description: '',
        constructor: '',
        thumbnail: 'grouped.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'packedbubble'
          },
          legend: {
            itemMarginBottom: 4,
            margin: 0,
            padding: 0
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              }
            },
            packedbubble: {
              layoutAlgorithm: {
                splitSeries: true
              }
            }
          }
        },
        parseData: 'packedbubble',
        plugins: ['packedbubble'],
        advancedParent: 'PackedBubble',
        sampleSet: 'packedbubble',
        dataValidator: false
      },
      Spiral: {
        title: 'Spiral',
        description: '',
        constructor: '',
        thumbnail: 'spiral.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'packedbubble'
          },
          legend: {
            itemMarginBottom: 4,
            margin: 0,
            padding: 0
          },
          plotOptions: {
            series: {
              marker: {
                enabled: true
              },
              lineWidth: 0
            },
            packedbubble: {
              useSimulation: false
            }
          }
        },
        parseData: 'packedbubble',
        plugins: ['packedbubble'],
        advancedParent: 'PackedBubble',
        sampleSet: 'packedbubble',
        dataValidator: false
      }
    }
  },
  'Polar area': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Polar area': {
        title: 'Polar area',
        description: '',
        constructor: '',
        thumbnail: 'oqajux.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'area',
            polar: true
          }
        },
        sampleSet: 'polar',
        advancedParent: 'Polar area',
        dataValidator: false,
        basic: {
          order: 19,
          thumbnail: 'polar.svg',
          icon: 'PolarArea'
        },
        parent: 'Polar area'
      },
      'Polar line': {
        title: 'Polar line',
        description: '',
        constructor: '',
        thumbnail: 'ajogud.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            type: 'line',
            polar: true
          }
        },
        sampleSet: 'polar',
        advancedParent: 'Polar area',
        dataValidator: false
      }
    }
  },
  'Wind rose': {
    description: '',
    icon: '',
    sampleData: [],
    templates: {
      'Wind rose': {
        title: 'Wind rose',
        description: '',
        constructor: '',
        thumbnail: 'windrose.svg',
        icon: '',
        sampleSets: [],
        validator: false,
        config: {
          chart: {
            polar: true,
            type: 'column'
          },
          pane: {
            size: '85%'
          },
          xAxis: {
            tickmarkPlacement: 'on'
          },
          yAxis: {
            min: 0,
            endOnTick: false,
            showLastLabel: true,
            reversedStacks: false
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              shadow: false,
              groupPadding: 0,
              pointPlacement: 'on'
            }
          }
        },
        sampleSet: 'windrose',
        dataValidator: false,
        advancedParent: 'Wind rose',
        basic: {
          order: 20,
          thumbnail: 'windrose.svg',
          icon: 'WindRose'
        },
        parent: 'Wind rose'
      }
    }
  }
};
